export default __webpack_public_path__ + "static/media/port2.eace4794.jpg";